"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var GanttChartHeaderWeek_1 = __importDefault(require("./GanttChartHeaderWeek"));
var utils_1 = require("../../../util/utils");
var GanttChartHeader = function (_a) {
    var currentDate = _a.currentDate;
    var createWeeks = function () {
        var weekArray = [];
        var range = utils_1.dateRange(currentDate);
        for (var i = 0; i < range.end.diff(range.start, 'w'); i++) {
            var week = utils_1.weekStart(range.start.add(i, 'w'));
            weekArray.push(react_1.default.createElement(GanttChartHeaderWeek_1.default, { key: week.valueOf(), week: week }));
        }
        return weekArray;
    };
    return (react_1.default.createElement("div", { className: 'gantt-chart-header' },
        react_1.default.createElement("div", { className: 'gantt-chart-header__weeks flex flex-row' }, createWeeks())));
};
exports.default = GanttChartHeader;
